import { basketRelease, reInitGiftVoucherBasket } from 'components/Basket/reducer'
import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        basket: state?.components?.basket?.data ?? null,
    }
}

const mapDispatchToProps = { basketRelease, reInitGiftVoucherBasket }

const hocEmptyBasket = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocEmptyBasket
